module.exports = __webpack_public_path__ + "static/media/iPhoneX2.efe07998.png";